// Shops pushed to grant the new Shopify scopes; cosmetic only, the modal can still be removed client-side
export const SCOPES_SKIP_BLACKLIST: ReadonlySet<string> = new Set<string>([
    'saddlethreads.myshopify.com',
    'rurong.myshopify.com',
    'publiassia-1703.myshopify.com',
    'black-veil-brides-vip.myshopify.com',
    'galligraphy-dev-store-1.myshopify.com',
    'test-certificacion-sandra.myshopify.com',
    '807ac5-2.myshopify.com',
    'iwizz.myshopify.com',
    'hgxfjm-12.myshopify.com',
    'ziuctj-tz.myshopify.com',
    'g3r9ns-98.myshopify.com',
    'k4rfms-dq.myshopify.com',
    'hfg0ba-yr.myshopify.com',
    'kissenliebe.myshopify.com',
    'etyrrr-de.myshopify.com',
    'cfqr4j-39.myshopify.com',
    'posterflow.myshopify.com',
    'storecuaseu.myshopify.com',
    'hungdt.myshopify.com',
    'oxitee-test.myshopify.com',
    'piper-lou-collection.myshopify.com',
    'myluv4dogs.myshopify.com',
    'fall-out-boy.myshopify.com',
    '6ae492.myshopify.com',
    '57af05-4e.myshopify.com',
    'spiderphoenix.myshopify.com',
    'x01vtm-0v.myshopify.com',
    'testshop-maria-normal.myshopify.com',
    'enenen-0915.myshopify.com',
    'ani-platform.myshopify.com',
    'th01nv-rp.myshopify.com',
    'health-career-compass.myshopify.com',
    'esia6r-k0.myshopify.com',
    'yiyiyi-0915.myshopify.com',
    'prod-alex-customily.myshopify.com',
    'yayaya-0915.myshopify.com',
    'aninitialimpression-2945.myshopify.com',
    'fe6a9f.myshopify.com',
    'b9d0b8-b9.myshopify.com',
    'da8234.myshopify.com',
    'gc4k0a-6x.myshopify.com',
    'mono-rasa.myshopify.com',
    'daef5f-3.myshopify.com',
    'touchpersonal.myshopify.com',
    'ks1cy1-w1.myshopify.com',
    '19e0ju-gx.myshopify.com',
    'test-collectorshub.myshopify.com',
    'potatoparcelbiz.myshopify.com'
]);

export const canSkipScopesUpdate = (shops: string[], blacklist: ReadonlySet<string> = SCOPES_SKIP_BLACKLIST): boolean =>
    !shops.some((shop) => blacklist.has(shop.trim().toLowerCase()));
